import React from "react";
import Label from "../label";
import MessageError from "../../message/__errors";
import "../styles.css";

// Многострочное текстовое поле.
export default function InputTextarea({ value = '', children, placeholder, errors, className = '', hasLabel = true, ...other }) {
    if (placeholder === undefined) placeholder = children;
    return <>
        {hasLabel ? <Label>{children}</Label> : null}
        <textarea
            {...other}
            value={value ? value : ''}
            className={`input ${className}`}
            placeholder={placeholder}
        />
        {errors ? <MessageError errors={errors}/> : null}
    </>;
}
